import type { CSSObject, Interpolation } from 'styled-components';
import { css } from 'styled-components';

export const sizes = {
  xl: 1599,
  lg: 1199,
  md: 1023,
  sm: 767,
  xs: 479,
};

type MediaType = {
  // eslint-disable-next-line
  [key in keyof typeof sizes]: any;
};

export const media: MediaType = Object.keys(sizes).reduce(
  (accumulator, label: 'xl' | 'lg' | 'md' | 'sm' | 'xs') => {
    accumulator[label] = (
      arg: CSSObject,
      ...args: Interpolation<CSSObject>[]
    ) => css`
      @media (max-width: ${sizes[label]}px) {
        ${css(arg, ...args)};
      }
    `;
    return accumulator;
  },
  {} as MediaType,
);

export const mediaQuery = {
  mobile: `max-width: ${sizes.sm}px`,
  tablet: `max-width: ${sizes.md}px`,
} as const;

let scrollPosition = 0;
export const toggleBodyScrollBar = (isHideScrollBar: boolean): void => {
  const html = document.getElementsByTagName('html')[0];
  const hideScroll = 'hide-scrollbar';

  if (isHideScrollBar) {
    scrollPosition = document.body.scrollTop || window.scrollY;
    html.classList.add(hideScroll);
  } else {
    html.classList.remove(hideScroll);
    if (scrollPosition !== 0) {
      window.scrollTo(0, scrollPosition);
    }
  }
};
